import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import ReactDOM from 'react-dom/client'
import 'react-toastify/dist/ReactToastify.css'
import ThemeProvider from './contexts/ThemeProvider.jsx'
import './main.css'
import Router from './router/Router.jsx'
import { isProduction } from './utils/constantes.js'
import SocketInitiator from './SocketInitiator.jsx'
import { setPageTitle } from './utils/pageTitle.js'

if (!isProduction) {
  // Indicate dev environment
  setPageTitle('Planning V3')
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
    <script src="http://localhost:8097"></script>
    <ThemeProvider>
      <Router />
      <SocketInitiator />
    </ThemeProvider>
  </LocalizationProvider>
)
